import React from "react";

import CtaButton from "../../components/shared/buttons/ctaButton";
import ContentCard from "../../components/cards/contentCard";
import { ConditionalSwiper } from "../../components/shared/conditionalSwiper";

export const InternshipTypes = ({
  title,
  subtitle,
  titleStyle,
  titleClass,
  subtitleContainerClass,
  subtitleClass,
  blocks,
  containerClass,
  descriptionContainerClass,
  headingContainerClass,
  headingOuterContainerClass,
  headingClass,
  headerTitleContainerClass,
  contentClass,
  contentWrapperClass,
  outerContainerClass,
  conditionalSliderOpts,
  primaryCtaLabel,
  primaryCtaLink,
  primaryCtaContainerClass,
  cardCtaContainerClass
}) => {
  const formattedBlocks =
    blocks?.map((cblock) => {
      return {
        ...cblock,
        title: cblock?.title ?? cblock?.genCgbTitle ?? "",
        description: cblock?.description ?? cblock?.genCgbSummary ?? "",
        subtitle: cblock?.subtitle ?? cblock?.genCgbSubtitle ?? "",
        imgUrl: cblock?.imgUrl ?? cblock?.genCgbImage?.sourceUrl ?? "",
        icon: cblock?.icon ?? cblock?.genCgbIcon?.sourceUrl ?? "",
        linkTitle: cblock?.linkTitle ?? cblock?.genCgbCtaTitle ?? "Learn more",
        externalLink: cblock?.genCgbExternalLink === true,
        url: cblock?.url ?? cblock?.genCgbCtaLink ?? ""
      };
    }) ?? [];

  return (
    <section className={`flex flex-col md:px-0 ${containerClass}`}>
      <div
        className={`container relative w-full mx-auto md:w-4/5 ${outerContainerClass}`}
      >
        {title && (
          <div
            className={`relative flex flex-col justify-center w-full ${headingOuterContainerClass}`}
          >
            <div
              className={`flex flex-col justify-center w-full h-0 py-2 mx-auto ${headingContainerClass}`}
            >
              <h1
                className={`font-light ${headingClass}`}
                dangerouslySetInnerHTML={{ __html: title }}
              />
            </div>
          </div>
        )}
        {subtitle && (
          <div
            className={`flex flex-col justify-center w-full h-0 py-2 mx-auto ${subtitleContainerClass}`}
          >
            <h1
              className={`font-light ${subtitleClass}`}
              dangerouslySetInnerHTML={{ __html: subtitle }}
            />
          </div>
        )}

        <div className={`flex flex-col md:flex-row gap-5 ${contentClass}`}>
          <ConditionalSwiper {...conditionalSliderOpts}>
            {formattedBlocks?.map((cardInfo, index) => (
              <ContentCard
                key={index}
                {...cardInfo}
                titleIcon={cardInfo.icon}
                titleClass={titleClass}
                ctaPosition="sm:mr-auto"
                cardCtaContainerClass={cardCtaContainerClass}
                titleStyle={titleStyle}
                externalLink={cardInfo.externalLink}
                type={cardInfo?.type ?? 3}
                headerTitleContainerClass={headerTitleContainerClass}
                descriptionContainerClass={descriptionContainerClass}
                contentWrapperClass={contentWrapperClass}
              />
            ))}
          </ConditionalSwiper>
        </div>
        {primaryCtaLink && (
          <div className={primaryCtaContainerClass}>
            <CtaButton
              preset={"primary"}
              ctaLabel={primaryCtaLabel}
              labelClass="text-base leading-genericCta font-bold pr-2"
              extraButtonStyle={"w-full"}
              to={primaryCtaLink}
            />
          </div>
        )}
      </div>
    </section>
  );
};

InternshipTypes.defaultProps = {
  containerClass: "px-4 bg-generic-bg planet:bg-gray-standard",
  headingContainerClass:
    "md:h-24 md:w-8/12 md:-mt-12 md:bg-gray-tertiary planet:md:bg-gray-darker",
  headingClass: "text-left sm:text-center text-generic-text planet:text-white",
  contentClass: "pt-0 pb-14 md:pt-32 md:pb-36",
  headingOuterContainerClass: "md:absolute",
  conditionalSliderOpts: {
    condition: true,
    slidesPerView: 1.2,
    spaceBetween: 10,
    centeredSlides: false,
    className: "w-full h-full"
  },
  subtitle: "",
  subtitleContainerClass: "",
  subtitleClass: "",
  titleStyle: "",
  titleClass: "",
  outerContainerClass: "",
  primaryCtaLabel: "",
  primaryCtaLink: "",
  primaryCtaContainerClass:
    "py-4 mx-auto w-full sm:w-1/4 flex flex-col sm:flex-row items-center sm:space-x-10 h-full",
  cardCtaContainerClass: ""
};
